// TypeScript types for the bakery signup system

export interface SignupData {
  fullName: string;
  phoneNumber: string;
}

export interface OTPData {
  otp: string;
  phoneNumber: string;
}

export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  message?: string;
  error?: string;
}

export interface ValidationErrors {
  fullName?: string;
  phoneNumber?: string;
  otp?: string;
}

export interface SignupContextType {
  signupData: SignupData | null;
  setSignupData: (data: SignupData) => void;
  currentStep: SignupStep;
  setCurrentStep: (step: SignupStep) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  error: string | null;
  setError: (error: string | null) => void;
}

export enum SignupStep {
  LANDING = 'landing',
  SIGNUP = 'signup',
  OTP_VERIFICATION = 'otp_verification',
  SUCCESS = 'success'
}

export interface Customer {
  id: string;
  fullName: string;
  phoneNumber: string;
  isVerified: boolean;
  createdAt: string;
}
